import { MDBFooter, MDBIcon, MDBRow, MDBCol, MDBContainer } from "mdb-vue-ui-kit";

export default {
    components: {
      MDBFooter,
      MDBIcon,
      MDBRow,
      MDBCol,
      MDBContainer
    }
}